import React from "react"
import CopyToClipboard from "react-copy-to-clipboard"

import {FormattedMessage} from "@irati/utils/lang"
import Button from "@irati/ui/src/Button"
import authentication from "@irati/auth"
import {H4} from "@irati/ui/src/Typography"

const SignUpLink = () => (
  <>
    <H4>
      <FormattedMessage
        id="admin.components.signUpLink.subdomain.text"
        values={{subdomain: authentication.userTenant().subdomain}} />
    </H4>
    <CopyToClipboard
      text={` ${authentication.userTenant().subdomain}.perkbox.com/signup`}>
      <Button id="settingsSelfSignUpCopyLink_button" marginTop={2} small>
        <FormattedMessage id="admin.components.signUpLink.copyToClipBoard.text" />
      </Button>
    </CopyToClipboard>
  </>

)

export default SignUpLink
